import { render, staticRenderFns } from "./eightCentresList.vue?vue&type=template&id=2aec67ba"
import script from "./eightCentresList.vue?vue&type=script&lang=js"
export * from "./eightCentresList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports